import VedioPlayer from '@Components/Common/VedioPlayer'
import React, { useRef } from 'react'

const IconSection = ({ handleClick, myRef }) => {

    return (
        <>
            <div className="new-landing-banner-sec">
                <section className="new-landing-banner">
                    <figure>
                        <img src="/images/discover_blueprint_new.jpg" alt="Banner Image" width='100%' onClick={handleClick} style={{ cursor: "pointer" }} />
                    </figure>

                    {/*<div className="container">
                        <div className="new-landing-banner-wrap">
                            <div className="new-landing-banner-text">
                                <h2>EXACTLY WHAT YOU NEED.<br /> NOTHING YOU DON’T. </h2>
                                <h6>
                                    DNA-Personalized<br />
                                    Supplement Formula<br />
                                    and Health Reports
                                </h6>
                                <div className="new-landing-banner-btn-wrap">
                                    <button onClick={handleClick}>SHOP NOW</button>
                                </div>
                            </div>
                            <div className="new-landing-banner-img">
                                <figure>
                                    <img src="/images/discover_blueprint.svg" alt="Banner Image" />
                                </figure>
                            </div>
                        </div>
                        </div>*/}
                </section>
            </div>

            <div className='as_seen_section' ref={myRef}>
                <div className="container">
                    <div className='logo-cstm-wrap'>
                        <ul>
                            <li>
                                <figure>
                                    <img src={`/images/nbcIcon.png`} alt='icons' loading='lazy' />
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src={`/images/fox.png`} alt='icons' loading='lazy' />
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src={`/images/abcIcon.png`} alt='icons' loading='lazy' />
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src={`/images/ocbs.png`} alt='icons' loading='lazy' />
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src={`/images/digitalJournal.png`} alt='icons' loading='lazy' />
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src={`/images/boston.png`} alt='icons' loading='lazy' />
                                </figure>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='new-section-vimeo'>
                <div className='left-img'><img src="/images/molecularleft1.png" alt='molecule' loading='lazy' /></div>
                <div className='right-img'><img src="/images/molecular_right.png" alt='molecule' loading='lazy' /></div>
                <div className="container">
                    <h2>HOW DOES IT WORK?</h2>
                    <div className="vimeo-wrap">
                        <VedioPlayer url="https://player.vimeo.com/video/970154296?autoplay=false&loop=0&autopause=0&muted=0" />

                    </div>
                </div>
            </div>
        </>
    )
}

export default IconSection